(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingMatchPassengers',
	};

	var $form;

	var client_changes = {};

	var _buildConfirmMessage,
	    _checkChangedData;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		// Display modal if cruise line is Royal Caribbean or Celebrity Cruise and number of passengers is more than 2
		let noPassengers = parseInt($('#booking_no_passengers').val());
		let cruiseLineId = parseInt($('#booking_cruise_line_id').val());
		let groupBooking = parseInt($('#booking_cruise_group').val());
		if (groupBooking === 1 && noPassengers > 2 && (cruiseLineId === 2 || cruiseLineId === 3)) {
			$('#group-cruise-passengers').modal('show');
		}
	});

	form.load = function load()
	{
		$form = $(form.element);

		$form.find('.p-new-or-existing').on('change', function change(e) {
			var $new_or_existing = $(this),
			    i                = $new_or_existing.data('p-index'),
			    $passenger       = $form.find('.passenger-' + i),
			    $name            = $passenger.find('.p-name');

			switch ($new_or_existing.val()) {
				case 'existing':
					$passenger.find('.p-new-client').addClass('hidden');
					$passenger.find('.p-clientid').val('');
					$passenger.find('.p-edit-existing').addClass('hidden');
					$passenger.find('.p-existing-client').removeClass('hidden');

					$name.val('');
					$name.removeClass('disabled');
					$name.prop('readonly', false);
					$name.focus();
					break;
				default:
					$passenger.find('.p-existing-client').addClass('hidden');
					$passenger.find('.p-new-client').removeClass('hidden');

					delete client_changes[i];
					_buildConfirmMessage();
					break;
			}
		});

		$form.find('.p-name').each(function iterator(i, input) {
			Adzuki.Typeahead(
				input,
				'/Clients/search',
				function select(item, $self, typeahead) {
					typeahead.setHiddenValue(item.id);

					_checkChangedData(i, item.id);
				}
			);
		});

		$form.find('.p-edit-existing').on('click', function change(e) {
			var i          = $(this).data('p-index'),
			    $passenger = $form.find('.passenger-' + i),
			    $name      = $passenger.find('.p-name');

			delete client_changes[i];
			_buildConfirmMessage();

			$passenger.find('.p-clientid').val('');
			$passenger.find('.p-edit-existing').addClass('hidden');

			$name.val('');
			$name.removeClass('disabled');
			$name.prop('readonly', false);
			$name.focus();
		});

		$form.find('.p-clientid').each(function iterator(i, input) {
			var client_id = $(input).val();

			if (client_id !== '') {
				_checkChangedData(i, client_id);
			}
		});
	};

	_buildConfirmMessage = function _buildConfirmMessage()
	{
		if ($.isEmptyObject(client_changes)) {
			form.confirm_message       = '';
			form.confirm_before_submit = false;
		} else {
			form.confirm_message = 'By proceeding with the selected clients, the following changes will occur to their client profiles in CP Maxx:<br><br>';

			$.each(client_changes, function iterator(i, client) {
				form.confirm_message += '<strong>' + client['name'] + '</strong><table>';

				$.each(client['changes'], function iterator(i, change) {
					form.confirm_message += '<tr><td>' + change['field'] + ':&nbsp;&nbsp;&nbsp;</td><td>' + change['from'] + ' <i class="'+Adzuki.FaIcon.getIconStyle('arrow_right')+'"></i> ' + change['to'] + '</td></tr>';
				});

				form.confirm_message += '</table><br>';
			});

			form.confirm_message       += 'Do you wish to continue?';
			form.confirm_before_submit  = true;
		}
	};

	_checkChangedData = function _checkChangedData(i, client_id)
	{
		var $passenger      = $form.find('.passenger-' + i),
		    $name           = $passenger.find('.p-name'),
		    passenger_title = $passenger.find('.p-passenger-title').data('value'),
		    gender_code     = $passenger.find('.p-gender-code').data('value'),
		    dob             = $passenger.find('.p-dob').data('value');

		$passenger.find('.p-edit-existing').removeClass('hidden');

		$name.addClass('disabled');
		$name.prop('readonly', true);

		Adzuki.Ajax.get('/CruiseBooking/loadClientDetails/' + client_id).then(function success(client_details) {
			var client = {
				name   : $name.val(),
				changes: {}
			};

			if (passenger_title !== '' && client_details['cpMaxxTitle'] !== passenger_title) {
				client['changes'][0] = {
					field: 'Prefix',
					from : ((client_details['cpMaxxTitle'] === '' || client_details['cpMaxxTitle'] === null) ? '(None)' : client_details['cpMaxxTitle']),
					to   : passenger_title
				};
			}

			if (client_details['genderCode'] !== gender_code) {
				client['changes'][1] = {
					field: 'Gender',
					from : ((client_details['genderCode'] === '' || client_details['genderCode'] === null) ? '(None)' : client_details['genderCode']),
					to   : gender_code
				};
			}

			if (dob !== '' && client_details['dob'] !== dob) {
				client['changes'][2] = {
					field: 'Date of Birth',
					from : ((client_details['dob'] === '' || client_details['dob'] === null) ? '(None)' : moment(client_details['dob']).format('M/D/YY')),
					to   : moment(dob).format('M/D/YY')
				};
			}

			if ($.isEmptyObject(client['changes'])) {
				delete client_changes[i];
			} else {
				client_changes[i] = client;
			}

			_buildConfirmMessage();
		});
	};

}(jQuery, window.Adzuki || {}));
